var map = {
	"./dlt_kind_1.png": "fb77",
	"./dlt_kind_10.png": "77c0",
	"./dlt_kind_2.png": "cbce",
	"./dlt_kind_7.png": "c4ff",
	"./dlt_kind_8.png": "a967",
	"./dlt_kind_9.png": "759e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c820";